
document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.hasAttribute('hidden');
      nav.toggleAttribute('hidden');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
});
